if (typeof loadeMoreSlider_G === 'undefined') {
	globalThis.loadeMoreSlider_G = null;
}

(function () {
	const isMobile = () => window.innerWidth < 990;

	const initSlider = () => {
		const sliders = document.querySelectorAll(".product-card-js");
		const dir = document.querySelector('html').getAttribute("dir");

		let nextEl = ".product-button-group .swiper-button-next";
		let prevEl = ".product-button-group .swiper-button-prev";
		if (dir === 'rtl') {
			[nextEl, prevEl] = [prevEl, nextEl];
		}
		sliders.forEach((slider, index) => {
			if (slider?.swiper) return;

			const disableMobileSlider = slider.hasAttribute('data-disable-mobile-slider');

			if (disableMobileSlider && isMobile()) {
				slider.classList.add('product-card-js--no-mobile-slider');
				return;
			}

			const productSlider = new Swiper(slider, {
				pagination: {
					el: ".product-pagination .swiper-pagination",
					clickable: true,
				},
				navigation: {
					nextEl: nextEl,
					prevEl: prevEl,
				},
				allowTouchMove: true,
				breakpoints: {
					990: {
						allowTouchMove: false,
					},
				},
			});

			// Desktop: auto-slide to second image on hover
			const cardWrapper = slider.closest('.card-wrapper');
			if (cardWrapper && productSlider.slides.length > 1) {
				cardWrapper.addEventListener('mouseenter', () => {
					if (!isMobile()) {
						productSlider.slideTo(1);
					}
				});
				cardWrapper.addEventListener('mouseleave', () => {
					if (!isMobile()) {
						productSlider.slideTo(0);
					}
				});
			}
		});
	};

	initSlider();
	loadeMoreSlider_G = initSlider;

	document.addEventListener("shopify:section:load", function () {
		initSlider();
	});
})();
